interface CardItem {
  title: string;
  tag: string;
  desc: string;
  imageUrl: string;
  imageAlt: string;
  stat: string;
}

const cards: CardItem[] = [
  {
    title: '霸道总裁的契约新娘',
    tag: '韩漫 · 恋爱',
    desc: '契约婚姻背后的真心，霸道总裁与倔强新娘的爱恨纠葛，每周三六更新。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20couple%20in%20a%20luxurious%20setting%2C%20female%20character%20in%20a%20beautiful%20gown%2C%20male%20character%20in%20a%20sharp%20suit%2C%20warm%20golden%20lighting%20with%20soft%20bokeh%20background%2C%20webtoon%20cover%20art%20style%2C%20clean%20simple%20background%20with%20warm%20tones%2C%20editorial%20quality%20digital%20illustration&width=600&height=800&seq=card-comic-01&orientation=portrait',
    imageAlt: '霸道总裁的契约新娘封面',
    stat: '1.2亿阅读',
  },
  {
    title: '剑道至尊',
    tag: '国漫 · 玄幻',
    desc: '少年持剑走天涯，以无上剑道问鼎苍穹，东方玄幻史诗巨作。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20of%20a%20young%20swordsman%20in%20flowing%20robes%20standing%20on%20a%20mountain%20peak%2C%20holding%20a%20glowing%20sword%2C%20dramatic%20clouds%20and%20misty%20landscape%20background%2C%20ink%20wash%20painting%20aesthetic%20with%20modern%20digital%20coloring%2C%20warm%20earthy%20tones%2C%20clean%20composition%2C%20cover%20art%20quality&width=600&height=800&seq=card-comic-02&orientation=portrait',
    imageAlt: '剑道至尊封面',
    stat: '9800万阅读',
  },
  {
    title: '放学后的秘密',
    tag: '日漫 · 校园',
    desc: '樱花树下的约定，藏在心底的初恋，温暖治愈的青春校园物语。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20illustration%20of%20two%20high%20school%20students%20under%20cherry%20blossom%20trees%2C%20soft%20spring%20lighting%20with%20pink%20petals%20falling%2C%20gentle%20and%20dreamy%20atmosphere%2C%20clean%20anime%20art%20style%2C%20warm%20pastel%20color%20palette%2C%20clean%20simple%20background%2C%20cover%20art%20quality%20digital%20illustration&width=600&height=800&seq=card-comic-03&orientation=portrait',
    imageAlt: '放学后的秘密封面',
    stat: '7600万阅读',
  },
  {
    title: '重生之逆天改命',
    tag: '韩漫 · 穿越',
    desc: '重生回到十年前，这一次她要改写命运，让所有对不起她的人付出代价。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20style%20illustration%20of%20a%20determined%20female%20character%20in%20an%20elegant%20dress%2C%20standing%20in%20a%20grand%20hall%20with%20dramatic%20lighting%2C%20reincarnation%20theme%20with%20clock%20and%20time%20visual%20elements%2C%20warm%20amber%20and%20deep%20red%20color%20palette%2C%20webtoon%20cover%20art%20style%2C%20clean%20composition%2C%20editorial%20quality&width=600&height=800&seq=card-comic-04&orientation=portrait',
    imageAlt: '重生之逆天改命封面',
    stat: '1.5亿阅读',
  },
  {
    title: '咒术战线',
    tag: '日漫 · 热血',
    desc: '咒术师与诅咒的终极对决，少年踏上最强咒术师的成长之路。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20action%20illustration%20of%20a%20young%20fighter%20in%20dynamic%20pose%20with%20energy%20effects%20surrounding%20him%2C%20dark%20supernatural%20theme%20with%20glowing%20cursed%20energy%2C%20intense%20expression%20and%20dramatic%20composition%2C%20warm%20orange%20and%20dark%20indigo%20color%20scheme%2C%20shonen%20manga%20cover%20art%20style%2C%20clean%20background%2C%20high%20quality%20illustration&width=600&height=800&seq=card-comic-05&orientation=portrait',
    imageAlt: '咒术战线封面',
    stat: '2.1亿阅读',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门推荐</h2>
          <p className="text-sm text-foreground-500">千万读者都在追的爆款漫画，你还没看吗？</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={card.imageUrl}
                  alt={card.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full bg-background-50/90 text-[10px] font-medium text-primary-700">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <span className="text-xs text-background-50 font-medium">{card.stat}</span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-900 mb-1 line-clamp-1">{card.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}